import { STRINGS } from './constant';

const { NAME } = STRINGS;

export const getError = state => state[NAME].error;
export const getMerchantsData = state => state[NAME].merchantsData;
export const getIsMerchantDataLoading = state => state[NAME].isMerchantDataLoading;
export const getHasMerchantDataLoaded = state => state[NAME].hasMerchantDataLoaded;
